import Lottie from 'lottie-web';

export default function setLottieIcons(className) {
  const block = document.querySelector(className);
  if (!block) return;

  const icons = block.querySelectorAll('.site-lottie-item');
  if (!icons || !icons.length) return;

  [...icons].forEach((icon) => {
    const path = icon.textContent || '';
    if (!path) return;

    icon.textContent = '';

    const data = {
      container: icon,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path
    };

    Lottie.loadAnimation(data);
  });
}
